import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import { deleteUserRequest, deleteUserSuccess, deleteUserFailure } from '../reducers/deleteUser';
import { toggleDeleteUserPopup } from '../reducers/view';
import { getTeamMembersFullRequest } from '../reducers/teamMembersFull';
import { API_LINK } from '../../constants';

const API = `${API_LINK}api`;

function* deleteUserFunctionAxios() {
  const state = yield select(fullState => fullState);
  const {
    user: { userId },
    token,
  } = state.loginReducer;
  const learnerId = state.teamMembersFullReducer.selectedTeamMemberId;

  const response = yield call(() =>
    axios({
      method: 'delete',
      url: `${API}/user/${learnerId}/lead/${userId}`,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: `Bearer ${token}`,
      },
      credentials: 'same-origin',
      data: {
        learnerId,
        userId,
      },
    }),
  );
  return response;
}

function* workerDeleteUserSaga() {
  try {
    const response = yield call(deleteUserFunctionAxios);
    const responseFromDeleteUser = response.data;

    if (response.status === 200) {
      yield put(deleteUserSuccess(responseFromDeleteUser));
      yield put(getTeamMembersFullRequest());
      yield put(toggleDeleteUserPopup(false));
    }
    if (response.status === 201) {
      yield put(deleteUserFailure(responseFromDeleteUser.message));
    }
  } catch (error) {
    yield put(deleteUserFailure(error.message));
  }
}

export function* watcherDeleteUserSaga() {
  yield takeLatest(deleteUserRequest().type, workerDeleteUserSaga);
}
